import Vue from 'vue';
Vue.filter('padZero', function (number) {
  return number ? number.toString().padStart(2, '0') : '';
});